export default "__VITE_ASSET__4oDxxnIu__"